import type { TeamRoles } from './rolesList';

export enum Feature {
  FEATURE_VIEW_SCORING_TASK = 'FEATURE_VIEW_SCORING_TASK',
  FEATURE_VIEW_LABELED_SERIES = 'FEATURE_VIEW_LABELED_SERIES',
}

export type TeamMember = {
  id: string;
  fullName: string;
  email: string;
  roles: string;
  organizationId: string;
  lastActivity: string;
  enabled: boolean;
  siteCodes: string;
  features: Feature[];
};

export type CreateTeamMemberConfig = {
  userId: string;
  role: TeamRoles;
  siteIds: string[];
  features: Feature[] | [];
};

export type EditTeamMemberConfig = {
  userId: string;
  features: Feature[];
};
